import React, { useEffect, useState } from 'react';
import { useSetUser, useUser } from '../hooks/user';
import userApi from '../api/user.api';

type Props = {
  children: React.ReactNode;
};

export default function LoadUserInfo(props: Props) {
  const setUser = useSetUser();
  const user = useUser();
  useEffect(() => {
    userApi.getProfile().then((res) => {
      setUser(res.data);
    });
  }, [setUser]);

  if (user) {
    return <>{props.children}</>;
  }

  return <pre>Loading...</pre>;
}
